function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon/Parter");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "icon/Parter",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Mask"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20,3 L11.1206922,6.98457426 L6.09747429,6.98457426 C4.94083375,6.98457426 4,7.84024351 4,8.89218468 L4,11.8330841 C4,12.8850253 4.94083375,13.7406945 6.09747429,13.7406945 L6.60716054,13.7406945 L10.288694,20.0828633 L10.3129315,20.1222872 C10.6685699,20.6638367 11.3206514,21 12.0149154,21 C12.3712529,21 12.7219973,20.911826 13.0296268,20.7450161 C13.9574096,20.2407711 14.2678358,19.1496179 13.7313485,18.3005193 L11.1502899,13.7546837 L20,17.4751599 L20,3 Z M18.1355784,14.8231574 L12.5287966,12.4664107 L12.5287966,8.24338518 L18.1358115,5.72767095 L18.1358115,14.8231574 L18.1355784,14.8231574 Z",
  id: "Shape",
  fill: "#829AB1",
  fillRule: "nonzero",
  mask: "url(#mask-2)"
})));

var SvgPartner = function SvgPartner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPartner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/partner.fcb4ac93.svg";
export { ForwardRef as ReactComponent };